import { delay, from, Observable, of } from "rxjs"

import { equityOrderUpdateResults } from "../mockData/orderHistoryData"
import { createMockOrderResponse } from "../mockData/orderServiceData"
import type {
  EquityOrderResponse,
  EquityOrderUpdateResult,
  IEquityOrderService,
  PlaceEquityOrderRequest,
} from "../OrderService"

export const EquityOrderService: Pick<
  IEquityOrderService,
  "createOrder" | "getOrders"
> = {
  createOrder: (
    input: PlaceEquityOrderRequest,
  ): Observable<EquityOrderResponse> =>
    of(createMockOrderResponse(input)).pipe(delay(1000)),

  getOrders(): Observable<EquityOrderUpdateResult> {
    return from(equityOrderUpdateResults).pipe(delay(200))
  },
}
